export default [
    {
        path: '/airport',
        props: true,
        component: () => import('@/views/Airport'),
    },
];